import { createContext, useContext } from 'react';
import { BaseBlock } from '@/declarations/models/blocks/BaseBlock';

export interface SectionBlocksContextValue {
  /** Inserts a block right after the block at the given index, in the current section */
  insertBlockAfter: (index: number, block: BaseBlock) => void;
}

export const SectionBlocksContext = createContext<SectionBlocksContextValue | null>(null);

/** Null outside a page editor section, e.g. in other editors that reuse the block components */
export const useSectionBlocks = () => useContext(SectionBlocksContext);
